import React from "react";
import { connect } from "react-redux";
import {
  fetchSummaryPageFields,
  sendEmail,
  toggleEmailModal,
  setBuyURL,
  toggleEmailSentModal,
} from "../../redux/actions/";
import { Header, SelectedRings } from "../../components";
import Footer from "../../components/Footer/Footer";
import "./_SummaryPage.scss";
import Ring from "../../components/Ring/Ring";
import Gallery from "../../components/Gallery/Gallery";
import PriceDisplay from "../../components/PriceDisplay/PriceDisplay";
import { withRouter } from "react-router-dom";
import queryString from "query-string";
import EmailModal from "../../components/EmailModal/EmailModal";
import { EmailSentModal } from "../../components/EmailSentModal/EmailSentModal";
const SHOPIFY_URL = process.env.REACT_APP_SHOPIFY_URL;

class SummaryPage extends React.Component {
  renderWishListBuySection = () => {
    const { shareButtonText, buyButtonText } = this.props;
    return (
      <div className="wish-buy-section">
        <button
          className="squared-button light-petrol"
          onClick={() => this.onShareButtonPress()}
        >
          {shareButtonText}
        </button>
        <button
          className="squared-button copper"
          onClick={() => this.onBuyButtonPress()}
        >
          {buyButtonText}
        </button>
      </div>
    );
  };

  onBuyButtonPress = () => {
    const buyURL = this.createBuyURL();

    if (buyURL) {
      window.location.href = buyURL;
    }
  };

  createBuyURL = () => {
    const mainRingShopifyProductId = this.getShopifyProductID(true);
    const holderRingsShopifyProductId = this.getShopifyProductID(false);
    let URL = "";
    if (mainRingShopifyProductId) {
      if (holderRingsShopifyProductId) {
        URL = `${SHOPIFY_URL}/cart/${mainRingShopifyProductId}:1,${holderRingsShopifyProductId}:2`;
      } else {
        URL = `${SHOPIFY_URL}/cart/${mainRingShopifyProductId}:1`;
      }
    } else if (holderRingsShopifyProductId) {
      URL = `${SHOPIFY_URL}/cart/${holderRingsShopifyProductId}:2`;
    }
    this.props.setBuyURL(URL);
    return URL;
  };

  getShopifyProductID = (mainRing = true) => {
    const { activeMainRing, activeHolderRings, history } = this.props;
    const queryParams = history
      ? queryString.parse(history.location.search)
      : null;
    if (mainRing) {
      if (queryParams && queryParams["ring-material"] && activeMainRing) {
        switch (queryParams["ring-material"]) {
          case "yellow-gold":
            return activeMainRing.fields.shopifyProductYellowGold;
          case "rose-gold":
            return activeMainRing.fields.shopifyProductRoseGold;
          case "white-gold":
            return activeMainRing.fields.shopifyProductWhiteGold;
          case "platinum":
            return activeMainRing.fields.shopifyProductPlatinum;
          default:
            return null;
        }
      }
    } else {
      if (queryParams && queryParams["holder-material"] && activeHolderRings) {
        switch (queryParams["ring-material"]) {
          case "yellow-gold":
            return activeHolderRings.fields.shopifyProductYellowGold;
          case "rose-gold":
            return activeHolderRings.fields.shopifyProductRoseGold;
          case "white-gold":
            return activeHolderRings.fields.shopifyProductWhiteGold;
          case "platinum":
            return activeHolderRings.fields.shopifyProductPlatinum;
          default:
            return null;
        }
      }
    }

    return null;
  };

  onShareButtonPress = () => {
    this.createBuyURL();
    this.props.toggleEmailModal();
  };

  render() {
    const {
      pageTitleText,
      backButtonText,
      priceText,
      redoButtonText,
      shareButtonText,
      activeMainRing,
      activeHolderRings,
      ringsChosenText,
      emailSent,
      emailModalTitleText,
      emailSentModalTitleText,
      emailSentModalText,
      emailSentModalButtonText,
    } = this.props;

    return (
      <div className="summary-page ojl-configurator-page">
        <Header titleText={pageTitleText} />
        <div className="selections">
          <Ring />
        </div>
        <Gallery />
        <div className="configurator-info">
          <SelectedRings
            title={ringsChosenText}
            mainRing={activeMainRing}
            holderRing={activeHolderRings}
          />
          <PriceDisplay title={priceText} />
        </div>
        {this.renderWishListBuySection()}
        <Footer
          backButtonText={backButtonText}
          redoButtonText={redoButtonText}
          shareButtonText={shareButtonText}
        />
        <EmailModal titleText={emailModalTitleText} />
        <EmailSentModal
          onClick={() => this.props.toggleEmailSentModal()}
          titleText={emailSentModalTitleText}
          text={emailSentModalText}
          buttonText={emailSentModalButtonText}
          open={emailSent}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ summaryPage, ring, configuratorPage }) => {
  const {
    pageTitleText,
    backButtonText,
    buyButtonText,
    priceText,
    redoButtonText,
    shareButtonText,
    wishListButtonText,
    buyURL,
    emailSent,
    emailModalTitleText,
    emailSentModalTitleText,
    emailSentModalText,
    emailSentModalButtonText,
  } = summaryPage;
  const { ringsChosenText } = configuratorPage;
  const { activeMainRing, activeHolderRings } = ring;

  return {
    pageTitleText,
    backButtonText,
    buyButtonText,
    priceText,
    redoButtonText,
    shareButtonText,
    wishListButtonText,
    activeMainRing,
    activeHolderRings,
    buyURL,
    ringsChosenText,
    emailSent,
    emailModalTitleText,
    emailSentModalTitleText,
    emailSentModalText,
    emailSentModalButtonText,
  };
};

export default connect(mapStateToProps, {
  fetchSummaryPageFields,
  sendEmail,
  toggleEmailModal,
  setBuyURL,
  toggleEmailSentModal,
})(withRouter(SummaryPage));
